import * as angular from 'angular';
import * as moment from 'moment';

import { ApplicationUserViewModel, ComponentDefinition, OnlineUserDto } from '../../models';

interface OnlineUserVM extends OnlineUserDto {
    delay: string;
    picture: string;
}

class OnlineUserController implements angular.IComponentController {
    model: OnlineUserVM;

    readonly onlineUser: OnlineUserDto;
    readonly user: ApplicationUserViewModel;

    static $inject = [];

    $onInit() {
        this.refresh();
    }

    $onChanges(_changes: angular.IOnChangesObject) {
        this.refresh();
    }

    private refresh() {
        const model = angular.copy(this.onlineUser) as OnlineUserVM;
        model.delay = moment(model.lastActionDate).fromNow();
        model.picture = this.user?.picture;
        this.model = model;
    }
}

export const wtOnlineUser: ComponentDefinition = {
    componentId: 'wtOnlineUser',
    controller: OnlineUserController,
    template: require('./onlineUser.component.html'),
    controllerAs: 'vm',
    transclude: true,
    bindings: {
        onlineUser: '<',
        user: '<'
    }
};